import { FeatureLink } from "@softmax/web-features/navigation";
import type { SiteLink } from "@softmax/web-features/site/records";
import type joinedStyles from "../account-pill.module.css";
import { isNavigationClick } from "../link-click";

export type MenuStyles = typeof joinedStyles;
export type MenuLink = SiteLink & { readonly current?: boolean };

export function MenuItem({
  link,
  styles,
  onNavigate,
}: {
  readonly link: MenuLink;
  readonly styles: MenuStyles;
  readonly onNavigate: (href: string) => void;
}) {
  const props = {
    href: link.href,
    className: styles.item,
    "aria-current": link.current ? ("page" as const) : undefined,
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (isNavigationClick(event)) onNavigate(link.href);
    },
  };
  return (
    <li>
      {link.external ? (
        <a {...props} rel="noreferrer">
          {link.label}
        </a>
      ) : (
        <FeatureLink {...props}>{link.label}</FeatureLink>
      )}
    </li>
  );
}
